import React, { useEffect } from "react";
import CircularProgress from "../CircularProgress";
import { message as toastNotification } from "antd";
import Auxiliary from "../../util/Auxiliary";

const AppNotificationContainer = ({ loading, error, setError, message }) => {
  useEffect(() => {
    if (!loading && error) {
      toastNotification.error(<span id="message-id">{error}</span>);
      setError(null);
    }
    if (!loading && message) {
      toastNotification.info(<span id="message-id">{message}</span>);
    }
  });

  return (
    <Auxiliary>
      {loading && <div className="gx-loader-view gx-loader-position">
        <CircularProgress />
      </div>}
    </Auxiliary>
  )
}

export default AppNotificationContainer;
